import { IconTypes } from "./types";
import { ReactComponent as Processor } from "../../../../assets/icons/medium/processor.svg";
import { ReactComponent as Flag } from "../../../../assets/icons/medium/flag.svg";
import { ReactComponent as Chat } from "../../../../assets/icons/medium/chat.svg";
import { ReactComponent as Star } from "../../../../assets/icons/medium/star.svg";
import { ReactComponent as ThumbsUp } from "../../../../assets/icons/medium/thumbsup.svg";
import { ReactComponent as Doc } from "../../../../assets/icons/medium/doc.svg";
import { ReactComponent as Search } from "../../../../assets/icons/medium/search.svg";
import { ReactComponent as Close } from "../../../../assets/icons/medium/close.svg";
import { ReactComponent as Warning } from "../../../../assets/icons/medium/warning.svg";
import { ReactComponent as Information } from "../../../../assets/icons/medium/information.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/medium/chevronDown.svg";
import { ReactComponent as ChevronLeft } from "../../../../assets/icons/medium/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "../../../../assets/icons/medium/chevronRight.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/medium/arrowLeft.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/medium/arrowRight.svg";
import { ReactComponent as ArrowUp } from "../../../../assets/icons/medium/arrowUp.svg";
import { ReactComponent as ArrowDown } from "../../../../assets/icons/medium/arrowDown.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/icons/medium/chevronUp.svg";
import { ReactComponent as ZoomIn } from "../../../../assets/icons/medium/zoomIn.svg";
import { ReactComponent as Account } from "../../../../assets/icons/medium/account.svg";
import { ReactComponent as Dashboard } from "../../../../assets/icons/medium/dashboard.svg";
import { ReactComponent as Monitor } from "../../../../assets/icons/medium/monitor.svg";
import { ReactComponent as Critical } from "../../../../assets/icons/medium/critical.svg";
import { ReactComponent as HorizontalLine } from "../../../../assets/icons/medium/horizontalLine.svg";
import { ReactComponent as Settings } from "../../../../assets/icons/medium/settings.svg";
import { ReactComponent as TrendUp } from "../../../../assets/icons/medium/trendUp.svg";
import { ReactComponent as TendDown } from "../../../../assets/icons/medium/tendDown.svg";
import { ReactComponent as Bell } from "../../../../assets/icons/medium/bell.svg";
import { ReactComponent as Location } from "../../../../assets/icons/medium/location.svg";
import { ReactComponent as SpeechBubble } from "../../../../assets/icons/medium/speechBubble.svg";

export const icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  ACCOUNT: <Account />,
  ARROWUP: <ArrowUp />,
  ARROWDOWN: <ArrowDown />,
  ARROWLEFT: <ArrowLeft />,
  ARROWRIGHT: <ArrowRight />,
  PROCESSOR: <Processor />,
  FLAG: <Flag />,
  CHAT: <Chat />,
  STAR: <Star />,
  THUMBSUP: <ThumbsUp />,
  DOC: <Doc />,
  SEARCH: <Search />,
  WARNING: <Warning />,
  INFORMATION: <Information />,
  CHEVRONLEFT: <ChevronLeft />,
  CHEVRONRIGHT: <ChevronRight />,
  CHEVRONDOWN: <ChevronDown />,
  CHEVRONUP: <ChevronUp />,
  ZOOMIN: <ZoomIn />,
  DASHBOARD: <Dashboard />,
  MONITOR: <Monitor />,
  CRITICAL: <Critical />,
  CLOSE: <Close />,
  HORIZONTALLINE: <HorizontalLine />,
  SETTINGS: <Settings />,
  TRENDUP: <TrendUp />,
  TENDDOWN: <TendDown />,
  BELL: <Bell />,
  LOCATION: <Location />,
  SPEECHBUBBLE: <SpeechBubble />,
};
